import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from "../../../../../environments/environment";
import {CommonResponse} from "../../../../shared/response/common.response";
import {UtilityService} from "../../../../shared/services/utility.service";

@Injectable({
    providedIn: 'root'
})
export class ApiReportefallaRepository {

    /**
     * Contiene la ruta de conexión a servicios publicos
     */
    API_URI = environment.API_URI;
    PUBLIC_URI = environment.PUBLIC_URI;

    constructor(private http: HttpClient, private utilityService: UtilityService) {
    }

    public async registrar(objeto: any): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.post(this.API_URI + 'reportefalla/reportefalla', objeto).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async getByTrabajadorID(trabajadorId): Promise<CommonResponse> {
        try {
            const responseSuccess = await this.http.get(this.API_URI + 'reportefalla/getByTrabajadorID/' + trabajadorId).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async obtenerListaPorPaginacion(busqueda: any, pagina: any, registros: any): Promise<CommonResponse> {
        try {
            const url: string = this.API_URI + 'reportefalla/listarPorPaginacion/' + busqueda + '/' + pagina + '/' + registros;
            const responseSuccess = await this.http.get(url).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

    public async listarPorEmpresaAnioSede(empresaId: any, anio: any, sedeId: any): Promise<CommonResponse> {
        try {
            const url: string = this.API_URI + 'reportefalla/listarPorEmpresaAnioSede/' + empresaId + '/' + anio + '/' + sedeId;
            const responseSuccess = await this.http.get(url).toPromise();
            return this.utilityService.parseData(responseSuccess);
        } catch (responseError) {
            return this.utilityService.parseData(responseError);
        }
    }

}
